import { z } from "zod";

/** A campaign's draft sign-off (`sign-offs.ts`). Its own module so the web bundle can import it. */
export const SignOffModeSchema = z.enum(["first_name", "none", "full_signature"]);
export type SignOffMode = z.infer<typeof SignOffModeSchema>;
export const DEFAULT_SIGN_OFF: SignOffMode = "first_name";

/** What each setting would add to a draft from one mailbox, as plain text; null adds nothing. */
export type SignOffPreviews = Record<SignOffMode, string | null>;
